import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        language: 'zh-TW',
        menuJson: '',
        testArr: [1, 2, 3, 4],
        spanLeft: 4,
        fullScreen: false,
        token: null,
        ticket: '',
        clickStatus: false,
        timezoom: localStorage.getItem('timezoom') !== undefined ? localStorage.getItem('timezoom') : '', // 时区存储
        active: '', // 左侧菜单当前所在页
        inGroup: 'index', // 当前所在业务、
        authType:'',
        inGroupId: '', // 当前所在业务的ID
        thisPage: '', // 当前所在页面
        breadMenu: { firstMenu: '', subMenu: [{ link: '', name: '', index: '' }] },
        userInfoList: [],
        roleData: [], // 菜单权限
        warehouseList: [] // 海外仓库数据
    },
    mutations: {
        testArr(state, data) { // 左侧距离数据
            state.spanLeft = data;
        },
        menuJson(state, data) { // 左侧菜单数据
            state.menuJson = data;
        },
        spanLeft(state, data) { // 左侧距离数据
            state.spanLeft = data;
        },
        breadMenu(state, data) { // 面包屑数据
            state.breadMenu = data;
        },
        token(state, data) { // token数据
            state.token = data;
        },
        ticket(state, data) { // ticket数据
            state.ticket = data;
        },
        inGroup(state, data) { // 当前所在业务
            state.inGroup = data;
        },
        authType(state, data) { // 当前所在业务
            state.authType = data;
        },
        thisPage(state, data) { // 当前所在页面
            state.thisPage = data;
        },
        inGroupId(state, data) {
            state.inGroupId = data;
        },
        active(state, data) {
            state.active = data;
        },
        fullScreen(state, data) { // 新权限保存状态通信
            state.fullScreen = data;
        },
        clickStatus(state, data) {
            state.clickStatus = data;
        },
        userInfoList(state, data) {
            state.userInfoList = data;
        },
        roleData(state, data) {
            state.roleData = data;
        },
        timezoomChange(state, data) {
            state.timezoomChange = data;
        },
        warehouseList(state, data) { // 海外仓库数据
            state.warehouseList = data;
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js